import {Routes} from '@angular/router';
import {ArrangementContentComponent} from './components/arrangement-content/arrangement-content.component';
import {PreArrangementContentComponent} from './components/pre-arrangement-content/pre-arrangement-content.component';
import {TransactionsContentComponent} from './components/transactions-content/transactions-content.component';
import {Dac6FormsContentComponent} from './components/dac6-forms-content/dac6-forms-content.component';
import {LibraryContentComponent} from './components/library-content/library-content.component';
import {PreArrangementDetailComponent} from './components/pre-arrangement-detail/pre-arrangement-detail.component';
import {ArrangementDetailComponent} from './components/arrangement-detail/arrangement-detail.component';
import {AddSectionComponent} from '@shared/components/add-section/add-section.component';
import {ManageSectionContentComponent} from '@shared/components/manage-section-data/manage-section-content/manage-section-content.component';
import {PreArrangemenntImportComponent} from './components/pre-arrangemennt-import/pre-arrangemennt-import.component';
import {ArrangementImportComponent} from './components/arrangement-import/arrangement-import.component';
import {FilingFormComponent} from './components/filing-form/filing-form.component';
import {CountriesContentComponent} from './components/countries-content/countries-content.component';
import {ReportingLogicContentComponent} from './components/reporting-logic-content/reporting-logic-content.component';
import {ManageTransactionComponent} from './components/manage-transaction/manage-transaction.component';
import {AuthGuard, BasketAuthGuard} from '@core/services/auth-guard.service';
import {CaseContentComponent} from './components/case-content/case-content.component';
import {SingleCaseContentComponent} from './components/single-case-content/single-case-content.component';
import {FilingManagerFormWorkflowComponent} from './components/filing-manager-form-workflow/filing-manager-form-workflow.component';
import {PreArrangementExportComponent} from './components/pre-arrangement-export/pre-arrangement-export.component';
import {ArrangementExportComponent} from './components/arrangement-export/arrangement-export.component';
import {TransactionExportComponent} from './components/transaction-export/transaction-export.component';
import {SummaryRulesContentComponent} from './components/summary-rules-content/summary-rules-content.component';
import {PreArrangemenntToArrangementComponent} from './components/pre-arrangemennt-to-arrangement/pre-arrangemennt-to-arrangement.component';
import {FilingContentComponent} from './components/filing-content/filing-content.component';
import { CreateFormWorkflowComponent } from './components/create-form-workflow/create-form-workflow.component';
import { ParticipantsEntityManagerComponent } from './components/participants/participants-entity-manager/participants-entity-manager.component';
import { ParticipantsEntityManagerImportComponent } from './components/participants/participants-entity-manager-import/participants-entity-manager-import.component';
import { ParticipantsEntityManagerExportComponent } from './components/participants/participants-entity-manager-export/participants-entity-manager-export.component';
import {ParticipantsManageEntitiesComponent} from './components/participants/participants-manage-entities/participants-manage-entities.component';
import { CanDeactivateComponentGuard } from '@core/services/can-deactivate-component-guard.service';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from "@shared/components/platform-tool/platform-tool-container/platform-tool-container.component";
import {SummaryRulesComparisonComponent} from "@features/dac6-reporter/components/summary-rules-comparison/summary-rules-comparison.component";

export const Dac6ReporterRoutes: Routes = [
  {
    path: 'dac6-reporter/dashboard',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dac6-reporter/overview',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/overview/filters/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/hallmark-countries',
    component: PlatformLinkCreatorComponent,
    canActivate: [BasketAuthGuard],
    data: {
      restrictedBasketInfo: [
        {
          basketId: 'dac6-mx',
          message: 'Hallmark Countries are currently not applicable and/or not supported for Mexico MDR.'
        },
        {
          basketId: 'dac6-gb',
          message: 'Hallmark Countries are currently not applicable and/or not supported for UK MDR.'
        }
      ]
    }
  },
  {
    path: 'dac6-reporter/reporting-logic',
    component: PlatformLinkCreatorComponent,
    canActivate: [BasketAuthGuard],
    data: {
      restrictedBasketInfo: [
        {
          basketId: 'dac6-mx',
          message: 'Reporting Logic is currently not applicable and/or not supported for Mexico MDR.'
        },
        {
          basketId: 'dac6-gb',
          message: 'Reporting Logic is currently not applicable and/or not supported for UK MDR.'
        }
      ]
    }
  },
  {
    path: 'dac6-reporter/summary-rules',
    component: PlatformLinkCreatorComponent,
    canActivate: [BasketAuthGuard],
    data: {
      restrictedBasketInfo: [
        {
          basketId: 'dac6-mx',
          message: 'Summary Rules are currently not applicable and/or not supported for Mexico MDR.'
        }
      ]
    }
  },
  {
    path: 'dac6-reporter/summary-rules/compare',
    component: SummaryRulesComparisonComponent,
    canActivate: [BasketAuthGuard],
    data: {
      restrictedBasketInfo: [
        {
          basketId: 'dac6-mx',
          message: 'Summary Rules are currently not applicable and/or not supported for Mexico MDR.'
        }
      ]
    }
  },
  {
    path: 'dac6-reporter/overview/case/:caseId',
    component: SingleCaseContentComponent,
  },
  {
    path: 'dac6-reporter/library/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/library/:countryCode',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/library',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/pre-arrangement/import',
    component: PreArrangemenntImportComponent,
  },
  {
    path: 'dac6-reporter/pre-arrangement/export',
    component: PreArrangementExportComponent,
  },
  {
    path: 'dac6-reporter/pre-arrangement/detail/:Id',
    component: PlatformLinkCreatorComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },
  {
    path: 'dac6-reporter/pre-arrangement/manage-section/:sourceType',
    component: ManageSectionContentComponent
  },
  {
    path: 'dac6-reporter/pre-arrangement/prearrangement-to-arrangement/:id',
    component: PreArrangemenntToArrangementComponent
  },
  {
    path: 'dac6-reporter/pre-arrangement',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/pre-arrangement/filters/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/pre-arrangement/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/pre-arrangement/link/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  // arrangement routes
  {
    path: 'dac6-reporter/arrangement/import',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/arrangement/import/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'dac6-reporter/arrangement/filing/:filingType/export',
    component: ArrangementExportComponent,
  },
  {
    path: 'dac6-reporter/arrangement/detail/:Id',
    component: PlatformLinkCreatorComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },
  {
    path: 'dac6-reporter/filingSettings/:id',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'dac6-reporter/filingSettings/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/arrangement/manage-section/:sourceType',
    component: ManageSectionContentComponent
  },
  {
    path: 'dac6-reporter/dac6-analytics',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'dac6-reporter/arrangement/link/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'dac6-reporter/arrangement/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'dac6-reporter/arrangement',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/arrangement/filing/:FILED_PERIOD',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/arrangement/filing/:filedPeriod/filters/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/arrangement/filing/:filedPeriod/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/arrangement/filing/:filedPeriod/link/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/arrangement/:Id',
    component: PlatformLinkCreatorComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },
  {
    path: 'dac6-reporter/transactions/export',
    component: TransactionExportComponent,
  },
  {
    path: 'dac6-reporter/transactions/manage-transaction',
    component: ManageTransactionComponent,
  },
  {
    path: 'dac6-reporter/transactions/detail/:id',
    component: ArrangementDetailComponent
  },
  {
    path: 'dac6-reporter/transactions/add-section/:sourceType',
    component: AddSectionComponent
  },
  {
    path: 'dac6-reporter/transactions/manage-section/:sourceType',
    component: ManageSectionContentComponent
  },
  {
    path: 'dac6-reporter/transactions',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard, BasketAuthGuard],
    data: {
      restrictedBasketInfo: [
        {
          basketId: 'dac6-mx',
          message: 'Transactions are currently not applicable and/or not supported for Mexico MDR.'
        },
        {
          basketId: 'dac6-gb',
          message: 'Transactions are currently not applicable and/or not supported for UK MDR.'
        }
      ]
    }
  },
  // filing manager routes
  {
    path: 'dac6-reporter/filing-manager/forms/create/:arrangementId/:formTemplateId',
    component: FilingManagerFormWorkflowComponent,
  },
  {
    path: 'dac6-reporter/filing/manage-section/:sourceType',
    component: ManageSectionContentComponent
  },
  {
    path: 'dac6-reporter/filing-manager/forms',
    component: Dac6FormsContentComponent,
  },
  {
    path: 'dac6-reporter/filing-manager/forms/create-form-workflow',
    component: CreateFormWorkflowComponent,
  },
  {
    path: 'dac6-reporter/filing-manager/forms/:FormId',
    component: PlatformLinkCreatorComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },
  {
    path: 'gmt/scenarios/forms/:FormId',
    component: PlatformLinkCreatorComponent,
    canDeactivate: [CanDeactivateComponentGuard]
  },

  {
    path: 'dac6-reporter/filing-manager/forms/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/filing-manager/due-dates',
    component: FilingContentComponent,
  },
  {
    path: 'dac6-reporter/filing/:FilingType',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dac6-reporter/filing/:filingType/filters/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/filing/:filingType/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/filing-errors/:toolId/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/filing/:filingType/link/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'dac6-reporter/participants/:toolName',
    component: PlatformLinkCreatorComponent,
    canActivate: [BasketAuthGuard],
    data: {
      restrictedBasketInfo: [
        {
          basketId: 'dac6-mx',
          message: 'Other Persons are currently not applicable and/or not supported for Mexico MDR.'
        },
        {
          basketId: 'dac6-gb',
          message: 'Other Persons are currently not applicable and/or not supported for UK MDR.'
        }
      ],
      paramKey: 'toolName',
      paramValue: 'other-persons',
      dynamicParameterToResolve: [':toolName']
    }
  },
  {
    path: 'dac6-reporter/participants/:toolName/filters/:magicLinkId',
    component: PlatformToolContainerComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/link/:magicLinkId',
    component: PlatformToolContainerComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/manage-entities/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/import',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/import/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/export',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/manage-section/:sourceType',
    component: ManageSectionContentComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/:caseId',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/participants/:toolName/:caseId/export',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'dac6-reporter/transmissions',
    component: PlatformLinkCreatorComponent,
    data: {dynamicParameterToResolve: [':toolName']}
  },
  {
    path: 'transmissions/:toolId/:magicLinkId',
    component: PlatformToolContainerComponent
  },
];
